import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  isScheduleHistoryLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_SCHEDULE_HISTORY_SUCCESS:
    case actionTypes.FETCH_SCHEDULE_HISTORY_ERROR:
      return action.payload;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.FETCH_SCHEDULE_HISTORY:
          return Object.assign({}, state, { isScheduleHistoryLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.FETCH_SCHEDULE_HISTORY:
          return Object.assign({}, state, { isScheduleHistoryLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
